export default function addLoopParameter() {
  const pageThings100Element = document.querySelector(
    '.page-template-page-100-things',
  );
  if (pageThings100Element === null) return;

  const youtubeBlocks = document.querySelectorAll(
    '.wp-block-embed.is-type-video.is-provider-youtube',
  );
  youtubeBlocks.forEach((youtubeBlock) => {
    const youtubeIframe = youtubeBlock.querySelector('iframe');
    const youtubeSrc = youtubeIframe.getAttribute('src');
    const textLength = '/embed/'.length;
    const firstIndexNumber = youtubeSrc.indexOf('/embed/') + textLength;
    const lastIndexNumber = youtubeSrc.indexOf('?');
    const youtubeID = youtubeSrc.slice(firstIndexNumber, lastIndexNumber);
    const loopYoutubeSrc = `https://www.youtube.com/embed/${youtubeID}?feature=oembed&loop=1&playlist=${youtubeID}`;
    youtubeIframe.setAttribute('src', loopYoutubeSrc);
  });
}
